import type { FC } from "react";
import { WhatIfEarlierViz } from "web_myplann/Goals/Components/WhatIf/WhatIfEarlierViz";
import { WhatIfMoreViz } from "web_myplann/Goals/Components/WhatIf/WhatIfMoreViz";
import type { WhatIfScenario } from "web_myplann/Goals/Hooks/useWhatIfScenarios";
import type { ExtraContributionImpact } from "web_myplann/Goals/Types/ExtraContributionImpact";
import type { CurrencyEnum } from "web_myplann/Infrastructure/Api/Api";

type Props = {
	scenario: WhatIfScenario;
	impact: ExtraContributionImpact;
	savedLabel: string;
	currencyCode?: CurrencyEnum;
};

export const WhatIfCardViz: FC<Props> = ({
	scenario,
	impact,
	savedLabel,
	currencyCode,
}) =>
	scenario === "earlier" ? (
		<WhatIfEarlierViz impact={impact} savedLabel={savedLabel} />
	) : (
		<WhatIfMoreViz impact={impact} currencyCode={currencyCode} />
	);
